import { useState, useEffect } from "react";
import MultipleSelectChip from './MultipleSelectChip';
import TreeChart from "./TreeChart";

function getDepartments(data){
  //Get the name for all children
  let departments = data[0].children.map(c => c.name)
  departments.sort()
  return departments
}
function getOccupations(data){
  //Get the name for all children
  let occupations = data[0].children.map(c => (
    c.children.map(c => c.name)
  ))
  //concatenate all arrays
  occupations = [].concat.apply([], occupations)
  //Get unique values
  occupations = [...new Set(occupations)]
  occupations.sort()
  return occupations
}
function filterOccupations(data, selection = []) {
  //if empty selection return all departments
  if (selection.length === 0 || selection === null) {
    return data
  }
  //filter occupations
  let filteredOccupations = structuredClone(data)
  filteredOccupations.forEach(c => {
    c.children.forEach(c => {
      c.children = c.children.filter(c => selection.includes(c.name))
    })
    filteredOccupations.forEach(c => {
      c.children = c.children.filter(c => c.children.length !== 0)
    })
  })
  return filteredOccupations
}

function filterDepartments(data, selection = []) {
      //if empty selection return all departments
      if (selection.length === 0 || selection === null) {
        return data
      }
      let dataClone = structuredClone(data)
      //filter departments
      dataClone.forEach(c => {
        c.children = c.children.filter(c => selection.includes(c.name))
      })
      return dataClone
}

const Main = (props) => {
  //Load data
  const [graphData, setGraphData] = useState(null)
  const [filteredGraphData, setFilteredGraphData] = useState(null)
  const [departments, setDepartments] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [selOccupations, setSelOccupations] = useState([]);
  const [selDepartments, setSelDepartments] = useState([]);


useEffect(() => {
    fetch('./data.json')
      .then(response => response.json())
      .then(data => {
        setGraphData([data]);
        setFilteredGraphData([data]);
        setDepartments(getDepartments([data]));
        setOccupations(getOccupations([data]));
      });   
  }, []);

  function depInputHandler(data, value){
    let filteredDepartmentsData = filterDepartments(data, value);
    let filteredOccupations = getOccupations(filteredDepartmentsData);
    setOccupations(filteredOccupations)
    setSelDepartments(value)
    setSelOccupations([])
    setFilteredGraphData(filteredDepartmentsData)
  }

  function occInputHandler(data, selDepartments, value){
    let filteredDepartmentsData = filterDepartments(data, selDepartments);
    let filteredOccupationsData = filterOccupations(filteredDepartmentsData, value);
    setSelOccupations(value)
    setFilteredGraphData(filteredOccupationsData)
  }

  function TreeChartClickHandler(name, parent, children){
    if(name === "root"){
      setSelDepartments([])
      setSelOccupations([])
    } else if(children) {
      setSelDepartments([name])
    } else {
      setSelOccupations([name])
      setSelDepartments([parent])
    }
    //setSelDepartments([name])
  }

  //get the name for all children
  // const allOccupations = data[0].children.map(c => c.children.map(c => c.name))
  return (
    <div className=" 
    px-2 
    sm:px-4  
    py-2.5
    bg-th-blue-400 
    container 
    flex
    flex-wrap 
    mx-auto">
      <div className='w-full lg:w-1/3 h-[50%]'>
        <h1 className='text-2xl md:text-4xl text-th-white py-4 w-full'>How much does a government worker in Bermuda earn?</h1>
        <p className='text-md text-th-white font-bolt'>This visualization displays the salaries of all government employees in Bermuda, organized by <span className="text-th-purple">department</span> in the inner ring and <span className="text-th-green">occupation</span> in the outer nodes. The outer nodes represent the various <span className="text-th-green">occupations</span> within each <span className="text-th-purple">department</span>. To view the salary information for each <span className="text-th-green">occupation</span>, you can either click on a node in the graph or use the filters provided below.</p>
        <div className='bg-th-white rounded mt-5 mb-3'>
          {graphData && departments &&
            <MultipleSelectChip
              placeholder={"Select a department"}
              values={departments}
              setValue={selDepartments}
              handleInput={(value) => depInputHandler(graphData, value)} />}
        </div>
        <div className='bg-th-white rounded'>
          {graphData && occupations &&
            <MultipleSelectChip
              placeholder={"Select an occupation"}
              setValue={selOccupations}
              values={occupations}
              handleInput={(value) => occInputHandler(graphData, selDepartments, value)} />}
        </div>
        </div>
      <div className='bg-th-blue-400 w-full h-[87vh] mt-5 lg:w-2/3 lg:mt-0'>
        {graphData && <TreeChart data={filteredGraphData} valueInput={(selOccupations.length === 0 && selDepartments.length === 0) ? false : true} handleClick={(name, parent, children) => TreeChartClickHandler(name, parent, children)} />}
      </div>
    </div>
  )
};

export default Main;